import { render, staticRenderFns } from "./SearchSectionDetailView.vue?vue&type=template&id=85dea356&scoped=true"
import script from "./SearchSectionDetailView.vue?vue&type=script&lang=ts"
export * from "./SearchSectionDetailView.vue?vue&type=script&lang=ts"
import style0 from "./SearchSectionDetailView.vue?vue&type=style&index=0&id=85dea356&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85dea356",
  null
  
)

export default component.exports